import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3066ea77"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "date"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "iframe"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "article-content"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-left" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))

import articles, { State } from '@/store/channels/article';
import * as filters from '@/views/filters';
import { computed, onBeforeUnmount, onMounted, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Content from '../../articles/home/Content.vue';
import { setting } from '@/config';
import { isMobile } from '@/common/download'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()
const data = computed<State>(() => store.state[articles.name])
const feeds = computed(() => {
    if (data.value.feedIndex == -1) {
        return data.value.feeds
    } else {
        return [data.value.feeds[data.value.feedIndex]]
    }
})
const state = reactive({
    height: 0,
    width: 0,
    goTopVisible: false,
})

onMounted(() => {
    window.addEventListener('resize', onResize)
    window.addEventListener('scroll', onScroll)
    onResize()

    if (isMobile() && setting.first && data.value.article) {
        let url = "fuyintv://yuedu/article/" + data.value.article.itemid;
        window.location.href = url
    }
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize)
    window.removeEventListener('scroll', onScroll)
})

function onSelected(item: { islink: number, linkurl: string, itemid: number, }) {
    router.push(`/channels/articles/${item.itemid}.html`)
}

function onResize() {
    state.width = window.innerWidth
    state.height = window.innerHeight - 60
}
function onGoTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
}
function onScroll() {
    state.goTopVisible = window.scrollY > 300
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["articles-page", _unref(data).feedsVisible ? 'double' : 'single'])
  }, [
    (_unref(data).feedsVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "articles-contents",
          style: _normalizeStyle({ height: _unref(state).height + 'px' })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(feeds), (current) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["p1", { big: current.list.length == 1 }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(current.list, (item, i) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: "item",
                  onClick: ($event: any) => {onSelected(item); _unref(data).feedsVisible = _unref(state).width > 1100}
                }, [
                  (i == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(filters).date(item.addtime)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
                  _createElementVNode("div", {
                    class: "poster",
                    style: _normalizeStyle(_unref(filters).bg(item.thumb))
                  }, null, 4),
                  _hoisted_4
                ], 8, _hoisted_1))
              }), 256))
            ], 2))
          }), 256))
        ], 4))
      : _createCommentVNode("", true),
    (_unref(data).article && _unref(data).article.islink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("iframe", {
              src: _unref(data).article.linkurl
            }, null, 8, _hoisted_6)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (!_unref(data).feedsVisible)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "gobtn go-prev",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(data).feedsVisible = true))
              }, _hoisted_9))
            : _createCommentVNode("", true),
          (_unref(state).goTopVisible)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "gobtn go-top",
                onClick: onGoTop
              }, _hoisted_11))
            : _createCommentVNode("", true),
          _createVNode(Content, {
            article: _unref(data).article,
            channelMode: true
          }, null, 8, ["article"])
        ])),
    _hoisted_12
  ], 2))
}
}

})